import yorReducer from "./yorReducer";

export const YORReducer = { yorReducer };
